import { Modal, Box, Typography, TextField, Button, Fade, Backdrop, Stack } from '@mui/material';
import LocationPicker from './LocationPicker';
import { useState } from 'react';

const CheckoutModal = ({ open, onClose, onConfirm, total }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    instrucciones: '',
    coordenadas: null
  });

  const isReady = formData.nombre && formData.telefono && formData.coordenadas;

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition BackdropComponent={Backdrop}>
      <Fade in={open}>
        <Box sx={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 450 }, bgcolor: 'white', borderRadius: 3, p: 4, boxShadow: 24,
          maxHeight: '90vh', overflowY: 'auto'
        }}>
          <Typography variant="h6" fontWeight="900" mb={1}>Detalles de Entrega</Typography>
          <Typography variant="body2" color="text.secondary" mb={3}>Completa la información para procesar tu pedido.</Typography>

          <Stack spacing={2}>
            <TextField 
              label="Nombre Completo" fullWidth size="small" 
              onChange={(e) => setFormData({...formData, nombre: e.target.value})}
            />
            <TextField 
              label="Teléfono de contacto" fullWidth size="small" 
              onChange={(e) => setFormData({...formData, telefono: e.target.value})}
            />
            
            <Typography variant="subtitle2" fontWeight="bold">Ubicación de entrega:</Typography>
            <LocationPicker onLocationChange={(coords) => setFormData({...formData, coordenadas: coords})} />

            <TextField 
              label="Instrucciones adicionales (Ej: Portón azul, tocar timbre)" 
              multiline rows={2} fullWidth size="small"
              onChange={(e) => setFormData({...formData, instrucciones: e.target.value})}
            />

            <Button 
              variant="contained" fullWidth size="large"
              disabled={!isReady}
              onClick={() => onConfirm(formData)}
              sx={{ bgcolor: '#F7D060', color: 'black', fontWeight: 'bold', '&:hover': { bgcolor: '#eec140' } }}
            >
              Confirmar y Enviar (BOB {total.toFixed(2)})
            </Button>
          </Stack>
        </Box>
      </Fade>
    </Modal>
  );
};

export default CheckoutModal;